'use client';

import React, { JSX } from 'react';
import { BookingDetailsModule, useConfig } from '@ibe/components';
import Keys from '@/Translations/generated/en/booking-details.json.keys';
import { QueryUtils } from '@/Util/QueryUtils';
import useQuery from '@/Util/useQuery';
import Link from 'next/link';
import { useTranslation } from '@/app/i18n/client';
import YsnConfigModel from '@/Config/YsnConfigModel';
import { getLinkUrl } from '../linkList/Link';

interface Props {
  bookingListLink?: string;
}

const BookingOverview = ({ bookingListLink }: Props): JSX.Element => {
  const { t } = useTranslation('booking-details');

  const bookingId = QueryUtils.getBookingId(useQuery()) || '';

  const config = useConfig() as YsnConfigModel;

  return (
    <div className={'iso__bookingDetails'}>
      <Link href={getLinkUrl(bookingListLink, config)} className="btn btn-primary goBackButton">
        {t(Keys.backToList)}
      </Link>
      <div className="mt-5">
        <BookingDetailsModule bookingId={bookingId} hideCancelOption={true} />
      </div>
    </div>
  );
};

export default BookingOverview;
